<div class="comments">
  <div class="comments__body">
      @if (comments().length > 0) {
        <div class="comments__thread">
          @for (comment of comments(); track comment.id) {
            <div class="comment">
              <span class="comment__avatar" [style.background]="getAvatarColor(comment.author)">{{ getInitials(comment.author) }}</span>
              <div class="comment__body">
                <div class="comment__meta">
                  <span class="comment__author">{{ comment.author }}</span>
                  <span class="comment__date" [title]="(comment.createdAt | date: 'medium' : '+0100') + ' WAT'">{{ getRelativeTime(comment.createdAt) }}</span>
                </div>
                <p class="comment__text">{{ comment.text }}</p>
              </div>
            </div>
          }
        </div>
      } @else {
        <p class="comments__empty">No comments yet.</p>
      }

      <div class="comments__composer">
        <input
          #commentInput
          type="text"
          class="comments__input"
          placeholder="Add a comment…"
          aria-label="Add a comment"
          [value]="draft()"
          [disabled]="posting()"
          (input)="onDraftInput(commentInput.value)"
          (keydown.enter)="onPost()" />
        <button
          type="button"
          class="comments__post"
          [disabled]="!draft().trim() || posting()"
          (click)="onPost()">Post</button>
      </div>
    </div>
</div>
